<template>
  <!-- Form container -->
  <div class="theme-bg-white d-flex col-lg-4 align-items-center p-5">
    <!-- Inner container -->
    <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
    <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
      <div class="w-100">
        <!-- Logo -->
        <div class="d-flex justify-content-center align-items-center">
          <div class="ui-w-120">
            <div class="w-100 position-relative text-center">
              <!-- <img src="/img/Logo_v1.svg" alt="CDC Screening" aria-roledescription="logo" /> -->
              <!-- <svg class="w-100 h-100 position-absolute" viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stop-opacity=".25" offset="0"></stop><stop stop-opacity=".1" offset=".3"></stop><stop stop-opacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlink:href="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlink:href="#a"></linearGradient></defs><path class="fill-primary" transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg> -->
              <svg
              class="ml-2 mb-2"
        version="1.2"
        baseProfile="tiny"
        id="Layer_3"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 167.7 182.6"
        xml:space="preserve"
        height= "70"
      >
        <g>
          <path
            fill="#BB4230"
            d="M133.2,36.7c-2.2-7.9-5-15.5-11-21.5c-5.6-5.7-12-5.2-17,1.1c-2.6,3.3-4.6,6.9-6.4,10.7c-1.6-1.4-1.7-3.3-2.4-4.9c-2.4-5.9-5.1-11.6-9.7-16.1c-5.2-5.1-11-5.3-16.3-0.4C63,12.3,60,21.5,57.4,30.8c-9.7,34.9-10,70.3-3.7,105.8C55.9,149,59,161.4,66.2,172c7.4,10.9,16.3,12,24.2,0.2c2.6-3.9,4.7-8,6.3-12.4c0.5-1.3,0.5-2.9,2.1-3.8c1.7,3.8,3.7,7.5,6.2,10.8c4.9,6.4,11.2,6.9,17,1.3c3.7-3.5,6-7.9,7.9-12.5c5-12.1,7.3-24.8,8.6-37.7C141.5,90.4,140.7,63.3,133.2,36.7z M94.4,154.2c-2.3,1.6-4.4,3.5-7.7,2.2c-6-2.4-8.8-7.4-10.9-12.8c-6.8-17.3-8.5-35.5-8.4-53.9c0.1-17.3,1.9-34.5,8.4-50.9c1.6-4,3.8-7.7,7-10.8c1.9-1.7,4.1-1.9,5.8-2.6c4.8,0.1,8.6,4.7,7.5,8.6c-10.6,38.2-10.6,76.5-0.1,114.7C96.7,151.1,96.5,152.8,94.4,154.2z M131.2,126.4c-1.6,4.2-2.8,9.9-8.5,9.8c-5.8-0.1-7.2-5.6-8.9-10c-4.2-11.2-4.8-23-4.9-34.9c0.1-12,0.8-24,5.2-35.3c1.6-4.2,3.3-9.3,8.4-9.5c5.1-0.2,6.6,4.9,8.3,8.8c3,6.9,4.3,14.3,4.9,21.8C137.1,93.8,137,110.5,131.2,126.4z"
          />
        </g>
        <path
          fill="#BB4230"
          d="M55.2,168.6C28.7,158.5,1.7,128.3,1.9,90.1C2,54,28.5,23.8,55.6,13.1C35.7,35.2,27,61.4,27.1,90.7C27.1,120,35.3,146.4,55.2,168.6z"
        />
        <path
          fill="#BB4230"
          d="M166.2,90.7c-0.4,6.5-0.8,12.9-3.1,19.1c-0.8,2.2-1.7,4.7-4.5,4.7c-2.6,0-3.6-2.4-4.2-4.4c-4.1-13-4.1-26.2,0-39.2c0.6-2,1.7-4.4,4.2-4.4c2.9-0.1,3.7,2.5,4.5,4.6C165.4,77.3,165.8,84,166.2,90.7z"
        />
      </svg>
      <span class="text-danger e-eng-font demo e-light-bold e-ts-h5">&nbsp; ScreeningHub</span>
            </div>
          </div>
        </div>
        <!-- / Logo -->

        <h5 class="text-center font-weight-normal mt-5 e-nusx-8 mb-4">გთხოვთ გაიაროთ ავტორიზაცია</h5>

        <!-- Form -->

        <form @submit.prevent="handleSubmit" autocomplete="off">
          <div class="form-group">
            <label for="username" class="e-nusx-8">მომხმარებელი</label>
            <input
            autocomplete="off"
              type="text"
              v-model="username"
              id="username"
              name="username"
              class="form-control"
              :class="{ 'is-invalid': submitted && !username }"
            />
            <div v-show="submitted && !username" class="invalid-feedback">მომხმარებლის სახელი აუცილებელია</div>
          </div>
          <div class="form-group">
            <label for="password" class="e-nusx-8">პაროლი</label>
            <input
              type="password"
              v-model="password"
              id="password"
              name="password"
              class="form-control"
              :class="{ 'is-invalid': submitted && !password }"
            />
            <div v-show="submitted && !password" class="invalid-feedback">პაროლი აუცილებელია</div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary e-mtavr-17" :disabled="loggingIn">ავტორიზაცია</button>
            <img
              v-show="loggingIn"
              src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
            />
          </div>
        </form>
        <!-- <form class="my-5">
          <b-form-group label="მომხმარებელი" class="e-nusx-5">
            <b-input v-model="credentials.email" class="e-eng-font" />
          </b-form-group>
          <b-form-group>
            <div slot="label" class="d-flex justify-content-between align-items-end e-nusx-5">
              <div>პაროლი</div>
              <router-link
                href="javascript:void(0)"
                class="d-block small e-nusx-5"
                to="passwordRecovery"
              >დაგავიწყდა?</router-link>
            </div>
            <b-input type="password" v-model="credentials.password" />
          </b-form-group>

          <div class="d-flex justify-content-between align-items-center m-0">
            <b-check v-model="credentials.rememberMe" class="m-0 e-nusx-8">დაიმახსოვრე</b-check>
            <b-btn variant="danger" class="e-mtavr-17">შესვლა</b-btn>
          </div>
        </form> -->
        <!-- / Form -->

        <div class="text-center e-nusx-8">
          სისტემასთან წვდომის გასააქტიურებლად დაგვიკავშირდით:
          <p class="mt-3">
          <a href="https://www.facebook.com/Training.Center.CDC" class="text-secondary p-1"> <span class="fab fa-facebook-f"></span></a>
          <a href="tel:+995558161167" class="text-secondary p-1"> <span class="fas fa-phone-volume"></span></a>
          <a href="https://cdc.ge" class="text-secondary p-1"> <span class="fas fa-globe"></span></a>
          <a href="https://www.instagram.com/cdc_training/" class="text-secondary p-1"> <span class="fab fa-instagram"></span></a>
          <a href="https://www.linkedin.com/company/compliance-development-center/" class="text-secondary p-1"> <span class="fab fa-linkedin-in"></span></a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- / Form container -->
</template>

<!-- Page -->
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

<script>

export default {
  name: 'Login_Page_v1',
  metaInfo: {
    title: 'ავტორიზაცია'
  },
  data () {
    return {
      username: '',
      password: '',
      submitted: false
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.authentication.status.loggingIn
    }
  },
  created () {
    // reset login status
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    handleSubmit (e) {
      this.submitted = true
      const { username, password } = this
      const { dispatch } = this.$store
      if (username && password) {
        dispatch('authentication/login', { username, password })
      }
    }
  }
}
</script>
